export const API_TOKEN = PT.ApiToken;
export const CSRF_TOKEN = PT.CsrfToken;
export const CURRENT_CUSTOMER = PT.currentCustomer;
export const CURRENT_MEMBER = PT.currentMember;
